import { render, staticRenderFns } from "./tzproduct5.vue?vue&type=template&id=8186ce62&scoped=true"
import script from "./tzproduct5.vue?vue&type=script&lang=js"
export * from "./tzproduct5.vue?vue&type=script&lang=js"
import style0 from "./tzproduct5.vue?vue&type=style&index=0&id=8186ce62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8186ce62",
  null
  
)

export default component.exports